import { AppState } from '../index';

export const profileSelector = (state: AppState) => {
   return state.profile;
};

export const profileCountriesSelector = (state: AppState) => {
   return state.profile.data.meta.countries.data.map(item => ({ key: item.name, value: item.id }));
};
